import React from "react";
import { BadgeCheck, HeartHandshake, PackageCheck, ShieldCheck } from "lucide-react";

const reasons = [
  {
    icon: BadgeCheck,
    title: "Streetwear Fit",
    text: "Oversized silhouettes made to sit right on Indian body types.",
  },
  {
    icon: PackageCheck,
    title: "Drop-Ready Quality",
    text: "Premium cotton feel, durable stitching, and prints built for repeat wear.",
  },
  {
    icon: ShieldCheck,
    title: "Checkout Confidence",
    text: "Secure payments, COD support, and a clear return experience.",
  },
  {
    icon: HeartHandshake,
    title: "Designed For Daily Wear",
    text: "Bold enough for the fit check, comfortable enough for college, work, and weekends.",
  },
];

const WhyChooseSection = () => (
  <section className="px-4 py-20 md:px-8 md:py-28 lg:px-12" data-testid="why-choose-cynos">
    <div className="mb-10 max-w-3xl">
      <span className="font-mono text-xs uppercase tracking-[0.3em] text-cynos-red">Why Choose Cynos?</span>
      <h2 className="mt-2 font-anton text-5xl uppercase leading-none md:text-7xl">Built For The Indian Street.</h2>
    </div>
    <div className="grid gap-4 md:grid-cols-4 md:gap-5">
      {reasons.map(({ icon: Icon, title, text }) => (
        <article key={title} className="rounded-[8px] border border-white/10 bg-cynos-card p-5 transition-colors hover:border-white/30">
          <div className="mb-8 inline-flex h-11 w-11 items-center justify-center rounded-[8px] border border-cynos-red/40 bg-cynos-red/10 text-cynos-red">
            <Icon size={20} />
          </div>
          <h3 className="font-mono text-xs uppercase tracking-[0.2em] text-white">{title}</h3>
          <p className="mt-3 text-sm leading-6 text-zinc-400">{text}</p>
        </article>
      ))}
    </div>
  </section>
);

export default WhyChooseSection;
